import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import i18n from '@/libs/i18n'

export default function useRolesList() {
    // Use toast
    const toast = useToast()

    const refRolListTable = ref(null)

    // Table Handlers
    const tableColumns = [
        { key: 'name', label: i18n.t('Name'), sortable: true },
        { key: 'n_users', label: i18n.t('User Number'), sortable: true },
        { key: 'actions', label: i18n.t('Actions') },
    ]
    const perPage = ref(10)
    const totalRoles = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refRolListTable.value ? refRolListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalRoles.value,
        }
    })

    const refetchData = () => {
        refRolListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchRoles = (ctx, callback) => {
        store
            .dispatch('roles/fetchRoles', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const { roles, total } = response.data
                callback(roles)
                totalRoles.value = total
            })
            .catch((error) => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching roles list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }


    return {
        fetchRoles,
        tableColumns,
        perPage,
        currentPage,
        totalRoles,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refRolListTable,

        refetchData,
    }
}